export const siteConfig = {
  companyName: '元码科技',
  companyNameEn: 'YuanmaTech.com',
  phone: '13621720822',
  phoneDisplay: '136-2172-0822',
  address: '武汉东湖高新区，关山大道K11铭丰大厦15楼',
  email: 'contact@yuanmatech.com',
  wechatQrText: '扫码添加客服微信',
  slogan: '贴合业务、按需定制、稳定落地、源码交付、持续迭代、惠诚精工',
  seoKeywords: '软件外包,武汉软件外包定制,软件定制化,桌面软件开发,上位机开发,教培软件开发,在线考试系统开发,德育平台开发',
  coreValues: ['贴合业务', '按需定制', '稳定落地', '源码交付', '持续迭代', '惠诚精工']
}

export const navItems = [
  { name: '首页', path: '/' },
  { name: '成熟产品定制', path: '/solutions' },
  { name: '新闻资讯', path: '/news' },
  { name: '关于我们', path: '/about' },
  { name: '联系我们', path: '/contact' }
]
